import { ExportType } from 'shared/constants/export';
import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { ConversationAnalysis } from 'shared/interfaces/ConversationAnalysis';
import { User } from 'shared/interfaces/User';
import { VoiceCall } from 'shared/interfaces/VoiceCall';

export interface Conversation {
  _id: string;
  // User is not always populated therefore it can either be an id or a User object
  user?: string | User;
  smartAssistant?: string;
  handoffData?: HandoffData;
  createdAt: number;
  messages: ChatMessage[];
  archived: boolean;
  fileKey: string;
  title: string;
  analysis?: ConversationAnalysis;
  source: CouversationSource;
  voiceCall?: VoiceCall;
  takeoverData?: TakeoverData;
  updatedAt?: number;
}

export interface UpdateConversationTitleDto {
  conversationId: string;
  title: string;
}

export interface GetSmartAssistantConversationsQueryDto {
  start?: number;
  end?: number;
}

export interface ExportConversationsDto {
  smartAssistantId: string;
  query: GetSmartAssistantConversationsQueryDto;
  type: ExportType;
}

export interface UpdateConversationHandoffStatusDto {
  conversationId: string;
  status: HandoffStatus;
}

export interface SendConversationTakeoverMessageDto {
  conversationId: string;
  message: string;
}

export interface UpdateConversationTakeoverDataDto {
  conversationId: string;
  takeoverStatus: TakeoverStatus;
}

export enum ConversationSourceType {
  APP = 'app',
  WEBSITE = 'website',
  LINK = 'link',
  DISCORD = 'discord',
  ZAPIER = 'zapier',
  API = 'api',
  WHATSAPP = 'whatsapp',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  CALL = 'call'
}

export enum HandoffStatus {
  ALL = 'all',
  RESOLVED = 'resolved',
  UNRESOLVED = 'unresolved'
}

export enum HandoffType {
  EMAIL = 'email'
  // Add more types here
}

export interface HandoffData {
  email: string;
  name?: string;
  phone?: string;
  reason?: string;
  type: HandoffType;
  status: HandoffStatus;
}

export enum TakeoverStatus {
  ALL = 'ALL',
  ON = 'ON',
  OFF = 'OFF'
}

export interface TakeoverData {
  status: TakeoverStatus;
  reason?: string;
}

export interface WhatsAppConversationInfo {
  replyingPhoneNumberId: string;
  replyingPhoneNumber: string;
  senderPhoneNumber: string;
  senderName: string;
}

export interface FacebookConversationInfo {
  pageId: string;
  senderId: string;
  senderName: string;
}

export interface InstagramConversationInfo {
  instagramAccountId: string;
  senderId: string;
  senderUsername: string;
}

export interface CouversationSource {
  type: ConversationSourceType;
  discordChannelId?: string;
  whatsAppInfo?: WhatsAppConversationInfo;
  facebookInfo?: FacebookConversationInfo;
  instagramInfo?: InstagramConversationInfo;
}
